import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import MasterLayout from "../../masterLayout/MasterLayout";
import FormSucursal from "../../components/sucursal/FormSucursal";
import Loader from "../../components/Loader";
import { formSchema } from "../../validaciones/validacionSucursales";
import { apiFetch } from "../../utils/api";

const DetalleSucursalPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null)
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [datos, setDatos] = useState({
    id,
    nombre: '',
    calle: '',
    num_exterior: '',
    num_interior: '',
    colonia: '',
    codigo_postal: '',
    ciudad: '',
    estado: '',
    lat: 0.0,
    lon: 0.0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos({ ...datos, [name]: value });
  };

  const crearPayloadSucursal = () => ({
    nombre: datos.nombre,
    direccion: [
      datos.calle,
      datos.num_exterior,
      datos.num_interior,
      datos.colonia,
    ].filter(Boolean).join(' '),
    ciudad: datos.ciudad,
    estado: datos.estado,
    satEntityClave: null,
    satMunicipalityClave: null,
    codigoPostal: datos.codigo_postal,
    latitud: Number(datos.lat) || null,
    longitud: Number(datos.lon) || null,
    horaApertura: '07:00',
    horaCierre: '23:00',
    tiempoUso: 90,
  });

  const showWarning = (message) => {
    if (window.notie?.alert) {
      window.notie.alert({ type: "warning", text: message, time: 4 });
    } else {
      window.alert(message);
    }
  };

  const handleSave = async () => {
    const result = formSchema.safeParse(datos);
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    else{
      setError(null)
    }

    setIsSaving(true);
    try {
      const data = await apiFetch(id === "0" ? "/api/branches" : `/api/branches/${id}`,{
        method: id === "0" ? "POST" : "PUT",
        body: JSON.stringify(crearPayloadSucursal())
      });
      console.log(data);
      if(data.status){
        navigate(-1);
      } else {
        showWarning(data.message || "No se pudo guardar la sucursal.");
      }
    } catch (error) {
      console.error('Error:', error);
      showWarning(error.message || "No se pudo guardar la sucursal.");
    } finally {
      setIsSaving(false);
    }
  };
  
  useEffect(() => {
    if (id !== "0") {
      setIsLoading(true);
      try {
        apiFetch(`/api/branches/${id}`,{
          method: "GET",
        })
        .then((data) => {
          console.log(data);
          if(data.status){
	            let sucursal = data.data;
	            setDatos({
	              id: sucursal.id,
	              nombre: sucursal.nombre || '',
	              calle: sucursal.direccion || '',
	              num_exterior: sucursal.NUM_EXTERIOR_SUC || '',
	              num_interior: sucursal.NUM_INTERIOR_SUC || '',
	              colonia: sucursal.COLONIA_SUC || '',
	              codigo_postal: sucursal.codigoPostal || '',
	              ciudad: sucursal.ciudad || '',
	              estado: sucursal.estado || '',
	              lat: sucursal.latitud || 0.0,
	              lon: sucursal.longitud || 0.0,
	            });
          } else {
            showWarning(data.message || "No se pudo cargar la sucursal.");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
          showWarning(error.message || "No se pudo cargar la sucursal.");
          setIsLoading(false);
        });
      } catch (error) {
        console.error('Error:', error);
        showWarning(error.message || "No se pudo cargar la sucursal.");
        setIsLoading(false);
      }
    }
    else{      
      setIsLoading(false);
    }
  }, [id]);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormSucursal datos={datos} handleChange={handleChange} handleSave={handleSave} error={error} disabledButton={isSaving} />}
      </MasterLayout>
    </>
  );
};

export default DetalleSucursalPage;
